export function uTILITYINFOFORM2025GALLES() {
return [   //2024 Release 2025-05-04 10:54:00
 
{
   page: 0,
   name: "Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 64.68,
   left: 238.08,
   width: 337.08,
   height: 12.469
}
,
{
   page: 0,
   name: "Listing Agent", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 83.16,
   left: 256.92,
   width: 131.76,
   height: 12.469
}
,
{
   page: 0,
   name: "Date Of Completion", 
   fontSize: 9,
   type: "date",
   top: 83.16,
   left: 476.4,
   width: 95.04,
   height: 12.469
}
,
{
   page: 0,
   name: "Fulltime", 
   isText: false,
   type: "checkbox",
   top: 152.76,
   left: 333.24,
   width: 9.36,
   height: 9.36
}
,
{
   page: 0,
   name: "PartTime", 
   isText: false,
   type: "checkbox",
   top: 153.96,
   left: 402.12,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "STR", 
   isText: false,
   type: "checkbox",
   top: 153.96,
   left: 472.2,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Vacant", 
   isText: false,
   type: "checkbox",
   top: 153.96,
   left: 519.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Notes", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 172.64,
   left: 83.64,
   width: 489.48,
   height: 12.469
}
,
{
   page: 0,
   name: "PROPANE PROVIDER", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 209.225,
   left: 162.6,
   width: 111.24,
   height: 12.469
}
,
{
   page: 0,
   name: "Tank Size", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 208.88,
   left: 323.88,
   width: 33.36,
   height: 12.469
}
,
{
   page: 0,
   name: "Owned", 
   isText: false,
   type: "checkbox",
   top: 211.56,
   left: 366.12,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Leased", 
   isText: false,
   type: "checkbox",
   top: 211.56,
   left: 419.88,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Rent Fee", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 209.88,
   left: 522.6,
   width: 33.48,
   height: 12.469
}
,
{
   page: 0,
   name: "Last Fill Date", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 230.36,
   left: 115.56,
   width: 77.88,
   height: 12.469
}
,
{
   page: 0,
   name: "Gallons", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 231.36,
   left: 235.68,
   width: 39.00,
   height: 11.469
}
,
{
   page: 0,
   name: "Cost", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 231.36,
   left: 305.52,
   width: 50.04,
   height: 11.469
}
,
{
   page: 0,
   name: "Notes_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 231.36,
   left: 390.0,
   width: 183.6,
   height: 11.469
}
,
{
   page: 0,
   name: "NATURAL GAS PROVIDER", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 263.6,
   left: 179.28,
   width: 94.92,
   height: 12.469
}
,
{
   page: 0,
   name: "12Month Avg", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 263.6,
   left: 356.76,
   width: 33.36,
   height: 12.469
}
,
{
   page: 0,
   name: "High", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 263.6,
   left: 454.44,
   width: 41.76,
   height: 12.469
}
,
{
   page: 0,
   name: "Low", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 263.6,
   left: 532.08,
   width: 38.88,
   height: 12.469
}
,
{
   page: 0,
   name: "Notes_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 285.08,
   left: 83.64,
   width: 489.48,
   height: 11.469
}
,
{
   page: 0,
   name: "ELECTRIC PROVIDER", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 318.08,
   left: 157.8,
   width: 116.76,
   height: 12.469
}
,
{
   page: 0,
   name: "12Month Avg_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 318.08,
   left: 357.72,
   width: 33.36,
   height: 12.469
}
,
{
   page: 0,
   name: "High_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 318.08,
   left: 455.4,
   width: 41.76,
   height: 12.469
}
,
{
   page: 0,
   name: "Low_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 318.08,
   left: 532.92,
   width: 39.00,
   height: 12.469
}
,
{
   page: 0,
   name: "Notes Please specify if Solar is applicable", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 340.68,
   left: 247.8,
   width: 328.08,
   height: 11.469
}
,
{
   page: 0,
   name: "WATER PROVIDER", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 375.72,
   left: 167.4,
   width: 110.76,
   height: 11.469
}
,
{
   page: 0,
   name: "12Month Avg_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 375.72,
   left: 360.72,
   width: 33.36,
   height: 11.469
}
,
{
   page: 0,
   name: "High_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 375.72,
   left: 458.4,
   width: 41.76,
   height: 11.469
}
,
{
   page: 0,
   name: "Low_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 375.72,
   left: 535.92,
   width: 39.00,
   height: 11.469
}
,
{
   page: 0,
   name: "WellPrivate", 
   isText: false,
   type: "checkbox",
   top: 409.08,
   left: 123.24,
   width: 10.56,
   height: 10.56
}
,
{
   page: 0,
   name: "WellCommunity", 
   isText: false,
   type: "checkbox",
   top: 410.04,
   left: 201.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Cistern", 
   isText: false,
   type: "checkbox",
   top: 410.04,
   left: 299.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Yes", 
   isText: false,
   type: "checkbox",
   top: 410.04,
   left: 488.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "No", 
   isText: false,
   type: "checkbox",
   top: 410.04,
   left: 530.52,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Notes_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 426.72,
   left: 83.64,
   width: 489.48,
   height: 13.789
}
,
{
   page: 0,
   name: "Onsite system", 
   isText: false,
   type: "checkbox",
   top: 456.36,
   left: 93.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Yes_2", 
   isText: false,
   type: "checkbox",
   top: 456.36,
   left: 401.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "undefined", 
   isText: false,
   type: "checkbox",
   top: 456.36,
   left: 440.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "No Permit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 453.68,
   left: 520.08,
   width: 55.56,
   height: 12.789
}
,
{
   page: 0,
   name: "Notes_5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 473.16,
   left: 83.64,
   width: 489.48,
   height: 13.789
}
,
{
   page: 0,
   name: "TRASH PROVIDER", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 507.4,
   left: 145.56,
   width: 116.04,
   height: 12.789
}
,
{
   page: 0,
   name: "Cost_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 507.4,
   left: 298.2,
   width: 33.36,
   height: 12.789
}
,
{
   page: 0,
   name: "Notes_6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 507.4,
   left: 406.68,
   width: 163.44,
   height: 12.789
}
,
{
   page: 0,
   name: "INTERNET PROVIDER", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 540.76,
   left: 161.28,
   width: 100.20,
   height: 12.789
}
,
{
   page: 0,
   name: "Cost_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 540.76,
   left: 298.2,
   width: 33.36,
   height: 12.789
}
,
{
   page: 0,
   name: "Notes_7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 540.76,
   left: 406.68,
   width: 163.32,
   height: 12.789
}
,
{
   page: 0,
   name: "PROPERTY INSURANCE PROVIDER", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 576.52,
   left: 219.6,
   width: 89.64,
   height: 13.789
}
,
{
   page: 0,
   name: "Premium", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 576.52,
   left: 365.4,
   width: 38.88,
   height: 13.789
}
,
{
   page: 0,
   name: "Notes_8", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 576.52,
   left: 472.8,
   width: 100.32,
   height: 13.789
}
,
{
   page: 0,
   name: "PROPERTY OWNERS ASSOCIATION", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 629.56,
   left: 222.24,
   width: 147.60,
   height: 13.789
}
,
{
   page: 0,
   name: "Premium_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 629.56,
   left: 425.88,
   width: 39.00,
   height: 13.789
}
,
{
   page: 0,
   name: "undefined_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 629.56,
   left: 504.96,
   width: 38.88,
   height: 13.789
}
,
{
   page: 0,
   name: "Contact Notes PhoneWebsite", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 654.76,
   left: 212.76,
   width: 360.96,
   height: 13.789
}
,
{
   page: 0,
   name: "TelevisionSatellite", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 710.44,
   left: 140.88,
   width: 121.32,
   height: 13.7891
}
,
{
   page: 0,
   name: "Internet", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 710.44,
   left: 315.36,
   width: 121.20,
   height: 13.7891
}
] }
